export const position_config: any = {
  "top-right": {
    "& .MuiDialog-container": {
      justifyContent: "flex-end",
      alignItems: "start",
    },
    center: "",
  },
};
